import { render, staticRenderFns } from "./DefaultAboutDelivery.vue?vue&type=template&id=626e2221&scoped=true&"
import script from "./DefaultAboutDelivery.vue?vue&type=script&lang=js&"
export * from "./DefaultAboutDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e2221",
  null
  
)

export default component.exports